import * as React from 'react';

declare global {
  interface Window {
    // tslint:disable-next-line: no-any
    adsbygoogle: unknown[];
  }
}

type Props = React.HTMLProps<{}>;

const AdsMiddle1 = (_: Props) => {
  React.useEffect(() => {
    if (window.adsbygoogle) {
      window.adsbygoogle.push({});
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{
        display: 'block',
        height: '160px',
      }}
      data-ad-client={'ca-pub-7734657157218933'}
      data-ad-slot={'2375763404'}
      data-ad-format="horizontal"
    />
  );
};

export default AdsMiddle1;
